import { type ApolloCache } from '@apollo/client';
import { type GraphQLResultWithId } from './type-helpers';

export const invalidateObject = (typeName: string, id: string) => invalidateNode({ __typename: typeName, id });

/**
 * @param gid a Reconcept GID
 */
function getTypeFromId(gid: string) {
  const strVal = atob(gid);
  return /.*\/(.*?)\/\d+/.exec(strVal)?.at(1);
}

export const invalidateFieldsFromObject =
  (invalidationKeys: { gid: string; fields: string[] }[] = []) =>
  (cache: ApolloCache): void => {
    invalidationKeys.forEach((item) => {
      const type = getTypeFromId(item.gid);
      if (type) {
        cache.modify({
          id: type + ':' + item.gid,
          fields(fieldValue, details) {
            if (item.fields.find((key) => details.fieldName.startsWith(key))) {
              return details.DELETE;
            } else {
              return undefined;
            }
          },
        });
      } else {
        console.error('Cannot invalidate, id has no valid type', { id: item.gid, type });
      }
    });
  };

export const invalidateNode =
  (node: GraphQLResultWithId) =>
  (cache: ApolloCache): void => {
    if (!node.id) {
      console.error('No id to invalidate');
    }
    cache.evict({ id: `${node.__typename}:${node.id}` });
    cache.gc();
  };
